import { CloudinaryAsset } from '../../types/schemas/objects/CloudinaryAsset';
import { cloudinaryImageOptimizerLoader } from '../cloudinary/cloudinaryImageOptimizerLoader';
import { isCloudinaryAsset } from '../cloudinary/getCloudinaryAssetUrlAutoFormat';
import { getNextImageSrc } from '../cloudinary/getNextImageSrc';

export const getFallbackImgUrl = (fallbackImg?: CloudinaryAsset): string | undefined => {
	const fallbackImageUrl =
		fallbackImg?.url && isCloudinaryAsset(fallbackImg.secure_url)
			? cloudinaryImageOptimizerLoader(fallbackImg)({
					src: getNextImageSrc(fallbackImg),
					width: Number(fallbackImg.width) || fallbackImg.width,
				})
			: (fallbackImg?.secure_url ?? undefined);

	return fallbackImageUrl;
};
